import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Navbar from 'components/Navbar';
import { logout } from 'user/user.actions';
import { dirtyAlertAction, navigationAction } from 'ui/ui.actions';
import { resetAll } from 'property/properties.actions';
import { getCompanyLogo } from 'ui/ui.selectors';

function mapStateToProps(state) {
  const avatar = state.user.picture && state.user.picture.thumbnail;
  return {
    items: state.ui.navItems,
    logo: getCompanyLogo(state),
    isSmallScreen: state.ui.winWidth <= 576,
    avatar,
    dirty: state.ui.dirty,
    userName: state.user.fullName,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLogout: (cb) =>
      dispatch(logout())
        .then(() => dispatch(resetAll()))
        .then(() => dispatch(cb())),
    warnDirty: (to) => dispatch(dirtyAlertAction(to)),
    onNavigation: (to) => dispatch(navigationAction(to)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));
